/* src/app/shared-module/components/import-calling-contact/import-calling-contact.component.scss */
ion-button {
  --box-shadow: none !important;
  color: white;
  --background: var(--ion-color-secondary-shade) !important;
}
.col-button {
  text-align: end;
  margin-top: 10px;
  margin-bottom: 10px;
  padding-right: 10px;
  border-top: 1px solid var(--ion-color-secondary-shade);
}
.cancel-btn {
  margin-right: 10px;
}
/*# sourceMappingURL=import-calling-contact.component.css.map */
